import React from 'react'
import {useStyles} from "./ScoredScenesInPlaylist.css";
import {StyledTableCell, StyledTableRow} from "../../../../commons/utils/table/StyledTableSecondary.css";
import Paper from "@mui/material/Paper";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import LoadingProgressIndication from "../../../../commons/elements/progress/loading/LoadingProgressIndication";
import TagContainer from "../../../../commons/utils/disciplines/TagContainer";
import ScoredSceneSummarySlider from "../../videosScored/utils/sliders/ScoredSceneSummarySlider";
import DifficultyIndication from "../../../../commons/utils/difficulty/DifficultyIndication";
import {useIntl} from "react-intl";
import useLoadPlaylist from "../utils/useLoadPlaylist";
import ScoredSceneCardBasic from "../../videosScored/card/scoredSceneCardBasic/ScoredSceneCardBasic";
import ScoredSceneStatusIndication from "../../../../commons/utils/status/scoredScene/ScoredSceneStatusIndication";

const ScoredScenesInPlaylistSection = ({playlistKey}) => {
    const classes = useStyles();

    const {
        playlist,
        loading,
    } = useLoadPlaylist(playlistKey)

    // Internationalization for simple strings
    const intl = useIntl();

    // Show loading indication while loading the list of users
    if (loading) {
        return <LoadingProgressIndication
            text={intl.formatMessage({
                id: 'app.playlists.overview.table.expanded.loading',
                defaultMessage: 'Loading playlist scenes...'
            })}/>
    }

    return (
        <Paper className={classes.root}>
            <TableContainer component={Paper}>
                <Table size="small">

                    {/* Table header */}
                    <TableHead>
                        <TableRow>
                            <StyledTableCell align={"center"} width={"5%"} key="position">#</StyledTableCell>
                            <StyledTableCell align={"center"} width={"5%"} key="status">
                                {intl.formatMessage({
                                    id: 'app.playlists.overview.table.expanded.table.column.status',
                                    defaultMessage: 'Status'
                                })}
                            </StyledTableCell>
                            <StyledTableCell align={"center"} width={"45%"} key="video">
                                {intl.formatMessage({
                                    id: 'app.playlists.overview.table.expanded.table.column.video',
                                    defaultMessage: 'Video'
                                })}
                            </StyledTableCell>
                            <StyledTableCell align={"center"} width={"25%"} key='scoreSummary'>
                                {intl.formatMessage({
                                    id: 'app.playlists.overview.table.expanded.table.column.scoreSummary',
                                    defaultMessage: 'Score Summary'
                                })}
                            </StyledTableCell>
                            <StyledTableCell align={"center"} width={"5%"} key='difficulty'>
                                {intl.formatMessage({
                                    id: 'app.playlists.overview.table.expanded.table.column.difficulty',
                                    defaultMessage: 'Difficulty'
                                })}
                            </StyledTableCell>
                            <StyledTableCell align={"center"} width={"10%"} key='mainFocus'>
                                {intl.formatMessage({
                                    id: 'app.playlists.overview.table.expanded.table.column.mainFocus',
                                    defaultMessage: 'Main Focus'
                                })}
                            </StyledTableCell>
                            <StyledTableCell align={"center"} width={"5%"} key='athletesStartPosition'>
                                {intl.formatMessage({
                                    id: 'app.playlists.overview.table.expanded.table.column.startPosition',
                                    defaultMessage: 'Start Position'
                                })}
                            </StyledTableCell>
                        </TableRow>
                    </TableHead>

                    {/* Table rows */}
                    <TableBody>
                        {playlist.scoredScenes.map((scoredScene, index) => {
                            return (
                                <StyledTableRow hover key={scoredScene.key}>
                                    <StyledTableCell key="position">
                                        <div className={classes.positionOfScene}>{index + 1}.</div>
                                    </StyledTableCell>

                                    <StyledTableCell key='status'>
                                        <ScoredSceneStatusIndication statusInfo={scoredScene.statusInfo}/>
                                    </StyledTableCell>

                                    <StyledTableCell key="video">
                                        <ScoredSceneCardBasic scoredScene={scoredScene}/>
                                    </StyledTableCell>

                                    {/* Score summary "slider" */}
                                    <StyledTableCell key='scoreSummary'>
                                        <div className={classes.scoreSummaryRow}>
                                            <ScoredSceneSummarySlider scoredScene={scoredScene} timeFormat="mm:ss:SS"/>
                                        </div>
                                    </StyledTableCell>

                                    <StyledTableCell key='difficulty'>
                                        <DifficultyIndication difficulty={scoredScene.basics.difficulty}/>
                                    </StyledTableCell>

                                    <StyledTableCell key='mainFocus'>
                                        <TagContainer maxTags={3} tags={scoredScene.basics.mainFocus}/>
                                    </StyledTableCell>

                                    <StyledTableCell key='athletesStartPosition'>
                                        <div className={classes.athletePositionBoxContainer}>
                                            <div
                                                className={scoredScene.basics.athleteLeftPosition === 'red' ? classes.redBox : classes.blueBox}>
                                                {intl.formatMessage({
                                                    id: 'app.ids.abbreviation.athleteStartPosition.left',
                                                    defaultMessage: 'L'
                                                })}
                                            </div>
                                            <div
                                                className={scoredScene.basics.athleteLeftPosition === 'red' ? classes.blueBox : classes.redBox}>
                                                {intl.formatMessage({
                                                    id: 'app.ids.abbreviation.athleteStartPosition.right',
                                                    defaultMessage: 'R'
                                                })}
                                            </div>
                                        </div>
                                    </StyledTableCell>
                                </StyledTableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    )
}

export default ScoredScenesInPlaylistSection
